if (!customElements.get('component-sticky-cta')) {
  customElements.define('component-sticky-cta', class StickyCTA extends HTMLElement {
    constructor() {
      super();

      this.querySelectorAll('.sticky-cta__button').forEach(( ctaButton => {
        ctaButton.addEventListener('click', () => {
          window.sendGTMData && window.sendGTMData({
            event: 'sticky-cta-click'
          });
        })
      }));
    }
  });
}
